import solve from "./D12Bruteforce";
import {fieldOrder} from "./D12Game";

const $ = window.$;

$('.boardSelect').append(fieldOrder.map(fieldId => {
  let node = $('<option/>');
  node.text(fieldId);
  return node;
}));
$('#board_4').val('white');

const resultContainer = $('#result');
let form = $('form#form');
form.submit(e => {
  e.preventDefault();
  form.find('input,select').prop('disabled', true);
  window.requestIdleCallback(function() {
    let result = solve([0,1,2,3,4,5,6,7,8].map(i => form.find('#board_'+i).val()), Number(form.find('#hp').val()));
    if (typeof result === 'string') {
      resultContainer.append(result);
      return;
    }
    resultContainer.append("Died and checked other paths "+(result.permutations+result.others)+" times (found "+result.others+" others also winning but with less HP left) before finding this:");
    resultContainer.append("<br/><br/>");
    result.start.replay(result.win, line => {
      resultContainer.append(line);
      resultContainer.append("<br/>");
    })
  });
});
